import type { CronTimeFrame } from '@/types/schedule';
import type { FrequencyUnit } from '@/utils/cron/types';

import type { RecurringCronFormState } from './recurringCronSchedule';

/** Build API payload from recurring form when time frame is enabled. */
export function buildCronTimeFrameFromForm(
  mode: 'recurring' | 'fixed-time' | 'recurring-fixed-time',
  form: RecurringCronFormState
): CronTimeFrame | undefined {
  if (mode !== 'recurring' || !form.useTimeFrame) {
    return undefined;
  }

  return {
    fromHour: form.hoursFrom,
    fromMinute: 0,
    toHour: form.hoursTo,
    toMinute: 0,
    startingMinute: form.startingMinute,
    frequency: form.frequency,
    frequencyUnit: form.frequencyUnit,
  };
}

/** Override inferred window fields from stored author-local metadata. */
export function applyCronTimeFrameToForm(
  form: RecurringCronFormState,
  frame: CronTimeFrame
): RecurringCronFormState {
  const frequencyUnit: FrequencyUnit = frame.frequencyUnit === 'minutes' ? 'minutes' : 'hours';

  return {
    ...form,
    useTimeFrame: true,
    hoursFrom: frame.fromHour,
    hoursTo: frame.toHour,
    startingMinute: frame.startingMinute,
    frequency: frame.frequency,
    frequencyUnit,
  };
}

/** True when stored frame has valid window end for display/edit hydration. */
export function hasStoredCronTimeFrame(
  frame: CronTimeFrame | null | undefined
): frame is CronTimeFrame {
  return frame != null && typeof frame.toHour === 'number';
}
